// General meta tags
export const metaDesc = 'The Global Leader in Virtual Races and Fitness Challenges. Interactive, motivating, and fun. Earn medals and other rewards. Get started for free.';
export const metaUrl = 'https://yes.fit';
export const metaViewport = 'width=device-width, initial-scale=1.0, maximum-scale=5.0, user-scalable=yes';

// Open Graph specific meta tags
export const ogImage = 'https://asset.yes.fit/social/landing-600x600.png';
export const ogImageEvent = 'https://asset.yes.fit/social/events-600x600.png';
export const ogImageMember = 'https://asset.yes.fit/social/member-600x600.png';
export const ogTitle = 'Yes.Fit Virtual Races';
export const ogSiteName = 'Yes.Fit';
export const ogLocale = 'en_US';
export const ogType = 'website';

// Facebook specific meta tags
export const fbAppId ='573197069523922';

//Twitter specific meta tags
export const twitterHandle = '@Yesfit1';
export const twitterImage = 'https://asset.yes.fit/social/landing-600x314.png';
export const twitterImageEvent = 'https://asset.yes.fit/social/events-600x314.png';
export const twitterImageMember = 'https://asset.yes.fit/social/member-600x314.png';
export const twitterCardType = 'summary_large_image';
